import models from 'plugins/i18n/modelTypes.de.ts'

export default {
	activityFeed: {
		title: 'Aktualisierungen',
		from: 'von',
		created: 'angelegt',
		edited: 'bearbeitet',
		search: 'Im Verlauf suchen',
		noMatches: 'Keine Einträge zum Suchbegriff.',
		field_updated: '{field} wurde von {from} auf {to} aktualisiert',
		groups: {
			all: 'Alle',
			comments: 'Kommentare / E-Mails',
			status: 'Status',
			persons: 'Personen',
			links: 'Verknüpfungen',
			documents: 'Dokumente',
			data: 'Auftrags-/Meldungsdaten',
			other: 'Sonstiges',
		},
		reply: 'Antworten',
		systemUpdate: 'Systemaktualisierung',
		model: { ...models },
	},
}
